import React from 'react';

export default function VideoSection() {
  return (
    <section className="relative py-24 px-6 bg-black">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-red-600 text-xs font-bold uppercase tracking-wider">Watch the Magic</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Experience the Show
          </h2>
        </div>

        {/* New Videos - above existing */}
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          {/* Full video */}
          <div className="relative">
            <div className="absolute -inset-3 bg-red-600/20 rounded-2xl blur-xl"></div>
            <div className="relative rounded-xl overflow-hidden border-2 border-red-600/30 shadow-2xl shadow-red-600/20">
              <div className="aspect-video">
                <iframe
                  src="https://www.youtube.com/embed/HmrRICXqZYw"
                  title="Thomas is French - Performance Highlight"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>
            </div>
          </div>

          {/* YouTube Short - portrait */}
          <div className="relative flex justify-center">
            <div className="absolute -inset-3 bg-red-600/20 rounded-2xl blur-xl"></div>
            <div className="relative rounded-xl overflow-hidden border-2 border-red-600/30 shadow-2xl shadow-red-600/20 w-full max-w-[320px]">
              <div className="aspect-[9/16]">
                <iframe
                  src="https://www.youtube.com/embed/3DvnAxsXcvg"
                  title="Thomas is French - Short Clip"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        {/* Existing Videos */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* First Video */}
          <div className="relative">
            <div className="absolute -inset-3 bg-red-600/20 rounded-2xl blur-xl"></div>
            <div className="relative rounded-xl overflow-hidden border-2 border-red-600/30 shadow-2xl shadow-red-600/20">
              <div className="aspect-video">
                <iframe
                  src="https://www.youtube.com/embed/S_JXZ2b2Zu0"
                  title="Thomas is French - Performance Video 1"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Second Video */}
          <div className="relative">
            <div className="absolute -inset-3 bg-red-600/20 rounded-2xl blur-xl"></div>
            <div className="relative rounded-xl overflow-hidden border-2 border-red-600/30 shadow-2xl shadow-red-600/20">
              <div className="aspect-video">
                <iframe
                  src="https://www.youtube.com/embed/Wr6Wq2Xpk5c?start=169"
                  title="Thomas is French - Performance Video 2"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
